import React from 'react';

interface Props {
  children: React.ReactNode;
}

const ErrorBoundary = ({ children }: Props) => children;

export default ErrorBoundary;
